// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';

import {
    getPersons as listPersonsAPI,
    getPerson as getPersonAPI,
    addPerson as addPersonAPI,
    updatePerson as updatePersonAPI,
    deletePerson as deletePersonAPI,
} from '../../helpers/';

import { personsApiResponseError, personsApiResponseSuccess } from './actions';
import { PersonsActionTypes } from './constants';

function* getPerson({ payload: { id } }) {
    try {
        const response = yield call(getPersonAPI, id);
        const personItem = response.data.data;
        yield put(personsApiResponseSuccess(PersonsActionTypes.GET_PERSON, personItem));
    } catch (error) {
        yield put(personsApiResponseError(PersonsActionTypes.GET_PERSON, error));
    }
}

function* addPerson({ payload: person }) {
    try {
        const response = yield call(addPersonAPI, { ...person })
        const personItem = response.data
        yield put(personsApiResponseSuccess(PersonsActionTypes.ADD_PERSON, personItem))
    } catch (error) {
        yield put(personsApiResponseError(PersonsActionTypes.ADD_PERSON, error))
    }
}

function* updatePerson({ payload: person }) {
    try {
        const response = yield call(updatePersonAPI, { ...person })
        const personItem = response.data.data
        yield put(personsApiResponseSuccess(PersonsActionTypes.UPDATE_PERSON, personItem))
    } catch (error) {
        yield put(personsApiResponseError(PersonsActionTypes.UPDATE_PERSON, error))
    }
}
function* deletePerson({ payload: { id } }) {
    try {
        const response = yield call(deletePersonAPI, id)
        const personItem = response.data.id
        yield put(personsApiResponseSuccess(PersonsActionTypes.DELETE_PERSON, personItem))
    } catch (error) {
        yield put(personsApiResponseError(PersonsActionTypes.DELETE_PERSON, error))
    }
}

function* listPersons({ payload: params }) {
    try {
        const response = yield call(listPersonsAPI, { ...params });
        const listaPersons = response.data.data;
        yield put(personsApiResponseSuccess(PersonsActionTypes.LIST_PERSONS, listaPersons));
    } catch (error) {
        yield put(personsApiResponseError(PersonsActionTypes.LIST_PERSONS, error));
    }
}


export function* watchGetPerson(): any {
    yield takeEvery(PersonsActionTypes.GET_PERSON, getPerson);
}

export function* watchListPersons(): any {
    yield takeEvery(PersonsActionTypes.LIST_PERSONS, listPersons);
}

export function* watchAddPerson(): any {
    yield takeEvery(PersonsActionTypes.ADD_PERSON, addPerson)
}
export function* watchUpdatePerson(): any {
    yield takeEvery(PersonsActionTypes.UPDATE_PERSON, updatePerson)
}
export function* watchDeletePerson(): any {
    yield takeEvery(PersonsActionTypes.DELETE_PERSON, deletePerson)
}


function* personsSaga(): any {
    yield all([
        fork(watchGetPerson),
        fork(watchListPersons),
        fork(watchAddPerson),
        fork(watchUpdatePerson),
        fork(watchDeletePerson),
    ]);
}

export default personsSaga;
